import React from "react";

const ShowAnsweritem = (props) => {
  return (
    <div className="item-answer">
      {props?.question?.pic ? (
        <div>
          <img src={props?.question?.pic} alt="exam" />
        </div>
      ) : null}
      <p>
        {props?.question?.length === 0 ? null : props?.question?.description}{" "}
        {props?.question?.right_answers > 1 ? (
          <span className="more-answers">(بیش از یک مورد)</span>
        ) : null}
      </p>

      <div className="list-answer">
        {props?.question?.answers?.length ? (
          props?.question?.length === 0 ? null : (
            props?.question?.answers.map((info) => (
              <label className="answers" htmlFor={info.id} key={info.id}>
                <input
                  checked={Array.isArray(props.question.right_answers )? info.right_answer : info.right_answer}
                  type="checkbox"
                  name="answers"
                  id={info.id}
                />
                <span>{info?.description}</span>
              </label>
            ))
          )
        ) : (
          <div>
            <textarea
            value={props.rightAnswer}
              className="examInput"
              placeholder="پاسخ خود را اینجا بنویسید"
              rows={10}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ShowAnsweritem;
